import type { CityData } from "@/libs/bounce/cities"

export const getAllOfCityPoiListItemId = (city: Pick<CityData, "slug">) => `all-of-${city.slug}`
